import { render, staticRenderFns } from "./DetailExaminationTab.vue?vue&type=template&id=b5f8d558&scoped=true"
import script from "./DetailExaminationTab.vue?vue&type=script&lang=js"
export * from "./DetailExaminationTab.vue?vue&type=script&lang=js"
import style0 from "./DetailExaminationTab.vue?vue&type=style&index=0&id=b5f8d558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f8d558",
  null
  
)

export default component.exports